export const deviceEmulation = process.env.REACT_APP_DEVICE_EMULATION || '';
export const USE_FILE_PICKER = !!process.env.REACT_APP_USE_FILE_PICKER || false;



// WEBPACK FOOTER //
// ./src/config.js